import ILanguage from '@/admin/helpers/interfaces/language-types'
import { createModel } from '@rematch/core'
import { getAllFooter, importFooter, saveFooter } from '@/services/footer/footerService'
import { getAllLanguages } from '@/services/language/languageService';

const initialState: { footers: any, isloaded: boolean } = {
    isloaded: false,
    footers: []

}
export const footerModel = createModel()({
    state: { ...initialState },
    reducers: {

        setFooter(state, payload) {
            return {
                ...state,
                footers: payload.data,
            }
        },
        setIsLoading(state, payload){

            return {
                ...state,
                isloaded: payload

            }
        },

        setSelectedLanguage(state, payload){
 
            state.footers.footer.map((item:any, index: number)=>{
                if( item.style &&  item.style === "lang" ){
                    item.elements.map((lang: any, index: number)=>{
                        if(lang.title === payload){
                            lang.isSelected = true
                        }else{
                            lang.isSelected = false
                        }
                    }) 
                }

            })
            return state;
        }

     

    },
    effects: (dispatch) => ({

        
        async getFooterAsync() {
			 const response = await getAllFooter();
			if (response) { 		
                let language = {
                    success: true,
                    data: [
                        {
                            id: "66f06960ae8228a2220a0a06",
                            language: "Français",
                            isoCode: "fr",
                            flag: "/images/flag/FR.svg",
                            updatedAt: "2024-09-22T19:00:48.870000Z",
                            createdAt: "2024-09-22T19:00:48.870000Z"
                        },
                        {
                            id: "66f06960ae8228a2220a0a07",
                            language: "English",
                            isoCode: "en",
                            flag: "/images/flag/UK.svg",
                            updatedAt: "2024-09-22T19:00:48.894000Z",
                            createdAt: "2024-09-22T19:00:48.894000Z"
                        }
                    ],
                    message: "Success"
                };

                let langList: any = []

                  language && language?.data?.map((lang: any, index: number)=>{

                    langList = [...langList, {title: lang.language, href: "#", icon: lang.flag, isSelected: lang.language === "English" ? true : false, iSOCode: lang.isoCode }]

                  });


                  response.data?.footer?.map((item: any, index: number)=>{

                    if( item.style &&  item.style === "lang" ){
                        item.elements = langList;
                    }
                  })

                

                

               

			   this.setFooter({ data: response.data })
				return response
			} else {
				this.setFooter({ response: [] })
                return {}
			}

		},

        async saveFooterAsync(payload, rootState) {
			let response = await saveFooter(payload);
			if (response) {
				
				return response


			} else {
				console.log("else")

			}

		},
        async importFooter(payload){

            return await importFooter(payload)
        }

       


	}),

})